<template>
    <div class="">
        <div class="mb-6">
                <transition
                        enter-active-class="fade-out duration-[200ms]"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="fade-in duration-[300ms]"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0"
                        >
                    <div v-show="foodOrderPanelShown"
                    class="fixed top-0 left-0 right-0 bottom-0 w-[100vw] h-[100vh] z-40 overflow-y-auto bg-[#0008]">
                        <div
                            class="relative container-card p-6 m-4 z-0 overflow-hidden bg-white rounded-lg max-w-6xl"
                            @click.stop>
                            <button
                            @click.stop="foodOrderPanelShown = false; menuSearchQuery = ''"
                            aria-label="Close panel"
                            class="absolute top-3 right-3 z-60 text-gray-500 hover:text-gray-800 text-2xl font-bold"
                            >
                            &times;
                            </button>

                            <div class=" p-2 mt-2 z-0 bg-white overflow-hidden">
                                <div class="mb-6 flex justify-between items-center gap-4">
                                    <p class="text-2xl font-semibold font-inter">
                                        Order
                                    </p>
                                    <input
                                        type="text"
                                        v-model="menuSearchQuery"
                                        placeholder="Search menus..."
                                        class="text-sm border border-gray-300 input-ui w-full max-w-xs bg-transparent rounded-lg focus:ring-0 px-3 py-2"
                                    />
                                </div>
                                <div class="flex space-x-4">
                                    <div class="w-4/5 flex-1">
                                        <div class="flex w-full px-6 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                                            <ul class="flex flex-nowrap gap-x-3 mb-5 list-none border-b-0 pl-0" role="tablist" data-te-nav-ref>
                                                <li v-for="(category, index) in menuCategoryList" :key="index" role="presentation" class="shrink-0">
                                                    <button class="my-2 mr-3 text-white block px-7 pb-2.5 pt-3 text-xs rounded-full hover:isolate focus:isolate whitespace-nowrap"
                                                        @click="menuCategorySelectChanged(category)"
                                                        :class="category?.id === this.selectedMenuCategory.id ? 'bg-[#D45E5E]' : 'bg-[#c4c4c4]'">
                                                        {{ category.name }}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 overflow-y-auto max-h-[60vh] pr-2">
                                            <div
                                            v-for="menu in filteredMenuList"
                                            :key="menu.id"
                                            class="bg-white rounded-lg shadow hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
                                            >
                                                <img
                                                    :src="menu.image_url"
                                                    alt="menu"
                                                    class="h-32 w-full object-cover rounded-t-lg"
                                                />

                                                <div class="p-3 flex flex-col flex-1">
                                                    <div class="flex-1">
                                                        <h3 class="text-gray-800 font-medium text-md break-words">
                                                            {{ menu.name }}
                                                        </h3>
                                                        <h4 class="text-gray-800 font-medium text-sm break-words">
                                                            ({{ menu.description }})
                                                        </h4>

                                                        <p class="text-gray-600 text-sm mt-1">
                                                            {{ menu.prices[0].price.toLocaleString() }}
                                                        </p>
                                                    </div>

                                                    <button
                                                        class="mt-3 w-full bg-blue-600 text-white text-sm py-1.5 rounded hover:bg-blue-700 transition"
                                                        @click="addToOrderBtnClicked(menu)"
                                                    >
                                                        Add to Order
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- 🌀 Spinner while loading -->
                                            <div v-if="menuList.length < 1 && menuLoading" class="flex justify-center items-center h-40 text-gray-600">
                                                <svg
                                                    class="animate-spin h-8 w-8 text-[#D45E5E]"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24">
                                                    <circle
                                                    class="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    stroke-width="4"
                                                    ></circle>
                                                    <path
                                                    class="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                    ></path>
                                                </svg>
                                                <span class="ml-3">Loading menus...</span>
                                            </div>

                                            <!-- ❌ No Search Results -->
                                            <div
                                            v-else-if="menuSearchQuery.trim() && filteredMenuList.length === 0"
                                            class="flex flex-col justify-center items-center text-gray-500 h-40 col-span-full"
                                            >
                                            <svg
                                                class="h-10 w-10 text-gray-400 mb-2"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                stroke-width="2"
                                            >
                                                <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                                />
                                            </svg>
                                            <p class="text-center text-sm">No menus match your search.</p>
                                            </div>

                                            <!-- ❌ No Menus Available -->
                                            <div
                                            v-else-if="menuList.length === 0 && !menuLoading"
                                            class="flex flex-col justify-center items-center text-gray-500 h-40 col-span-full"
                                            >
                                            <svg
                                                class="h-10 w-10 text-gray-400 mb-2"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                stroke-width="2"
                                            >
                                                <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M3 12a9 9 0 1118 0A9 9 0 013 12z"
                                                />
                                            </svg>
                                            <p class="text-center text-sm">No menus available in this category.</p>
                                            </div>
                                        </div>
                                    </div>
<div class="w-1/5 flex-1">
    Cart Menus

    <div class="padding-section text-sm">
        <div class="grid grid-cols-10 gap-x-6 gap-y-5">
            <p class="text-black font-semibold col-span-5">
                Menu
            </p>
            <p class="text-black font-semibold col-span-4 text-right">
                Price
            </p>
            <div class="col-span-1"></div>
            
            <div v-for="(menu, index) in cartMenus" class="contents" :key="index">
                <button @click="openRemarkModal(index)" class="col-span-4 text-sm text-left group">
                    <span class="hover:underline text-blue-600 block font-medium">{{ menu.name }}</span>
                    <span v-if="menu.remark" class="text-xs text-gray-500 block italic font-normal">
                        Note: {{ menu.remark }}
                    </span>
                </button>
                
                <div class="col-span-3 text-center text-sm flex justify-between items-center">
                    <p>
                        {{ menu.quantity }}
                    </p>
                    <div>
                        <input class="input-check-pos" type="checkbox"
                            @change="updateCartMenusPriceTotal()"
                            v-model="cartMenus[index].foc_applied" value="" :id="'foc-' + index" />
                        <label class="inline-block pl-[0.15rem] hover:cursor-pointer" :for="'foc-' + index">
                            FOC
                        </label>
                    </div>
                </div>
                <p class="col-span-2 text-sm text-right">
                    <div v-if="cartMenus[index].foc_applied"><s>{{ (menu.price).toLocaleString() }}</s></div>
                    <div v-else>{{ (menu.price).toLocaleString() }}</div>
                </p>
                <button @click="removeMenuFromCart(menu, index)">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </div>

        <hr class="my-2"></hr>

        <div class="grid grid-cols-10 gap-x-6 gap-y-5 mt-2">
            <p class="text-black font-semibold col-span-4">
                Sub Total
            </p>
            <div class="col-span-2"></div>
            <p class="text-black font-semibold col-span-3 text-right">
                {{ (cartMenusPriceTotal + cartMenusFocTotal).toLocaleString() }}
            </p>
        </div>

        <hr class="my-2"></hr>

        <div class="grid grid-cols-10 gap-x-6 gap-y-5 mt-2">
            <p class="text-black font-semibold col-span-4">
                FOC
            </p>
            <div class="col-span-2"></div>
            <p class="text-black font-semibold col-span-3 text-right">
                {{ cartMenusFocTotal.toLocaleString() }}
            </p>
        </div>

        <hr class="my-2"></hr>

        <div class="grid grid-cols-10 gap-x-6 gap-y-5 mt-2">
            <p class="text-black font-semibold col-span-4">
                Total
            </p>
            <div class="col-span-2"></div>
            <p class="text-black font-semibold col-span-3 text-right">
                {{ (cartMenusPriceTotal).toLocaleString() }}
            </p>
        </div>
    </div>
</div>

<div v-if="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-md shadow-xl mx-4">
        <h3 class="text-lg font-bold text-gray-900 mb-1">
            Add Remark for {{ cartMenus[activeMenuIndex]?.name }}
        </h3>
        <p class="text-xs text-gray-500 mb-4">Add cooking instructions or customer notes.</p>
        
        <textarea 
            v-model="modalRemarkText" 
            placeholder="e.g., Less spicy, no onions..." 
            class="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3">
        </textarea>
        
        <div class="mt-4 flex justify-end gap-x-2">
            <button @click="closeRemarkModal" class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                Cancel
            </button>
            <button @click="saveRemark" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">
                Save
            </button>
        </div>
    </div>
</div>
                                </div>

                                <div class="flex justify-end">
                                    <button type="button" class="border rounded mx-1 p-1 w-16 bg-white text-black focus:shadow-none focus:outline-none"
                                    @click="cancelMenuOrder()">
                                        Cancel
                                    </button>
                                    <pos-loading-btn
                                    text="Order"
                                    loading-text="Ordering..."
                                    :loading="menuOrderBtnLoading"
                                    :explicitDisable="cartMenus.length < 1"
                                    @click="confirmMenuOrder()"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </transition>
            <div class="opacity-100 transition-opacity duration-150 ease-linear"
                :style="isShowSidebar == true ? 'width:calc(100% - 410px)' : 'width:100%' ">
                <div class="flex flex-wrap gap-x-4 gap-y-4">
                    <div v-for="(room, roomIndex) in roomList" :key="roomIndex"
                        :class="
                            room.booking
                                ? 'bg-yellow-400'
                                : room.is_active == 0
                                    ? 'bg-[#4fe0b7]'
                                    : 'bg-[#FF7675]'
                        "
                        class=" flex-shrink-0 flex-grow p-6 w-40 max-w-44 h-40">
                        <button @click="btnClickedIsOpenRoom(room, roomIndex)"
                            class="relative flex flex-col justify-between h-full w-full">
                            <div v-if="room.is_active == 1" class=" flex justify-between flex-col h-full">
                                <!-- <div>
                                    <p class="text-sm text-white">Start Time : {{ room.room_sessions[0].start_date ? room.room_sessions[0].start_date.slice(11,16) : '' }} </p>
                                    <p class="text-sm text-white">Start Time : {{ room.room_sessions[0].end_date ? room.room_sessions[0].end_date.slice(11,16) : '' }} </p>
                                </div> -->
                                <p class="text-base text-left text-white">
                                    {{ room.price_per_hour }}
                                </p>
                            </div>
                            <div class="absolute bottom-0 w-full flex justify-end">
                                <p class="text-base text-white font-semibold">
                                    {{ room.name }}
                                </p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <div class="fixed right-0 top-0 bottom-0 bg-white shadow-md ease-in-out duration-300 transition delay-100 pt-12 right-sidebar-2"
                :class="isShowSidebar == true ? 'translate-x-0 opacity-100 w-[400px]' : 'translate-x-full opacity-0 w-0' ">
                <div class="relative h-full w-full">
                    <div class="fixed right-4 top-4 z-40" :class="isShowSidebar == true ? 'block' : 'hidden' ">
                        <button @click="isShowSidebar = false"><i class="far fa-times"></i></button>
                    </div>
                    <div class="relative h-full " v-if="isOpenRoom.open_1 == true" id="open_room_1">
                        <div class="w-full h-full flex justify-center flex-col">
                            <div class="w-2/3 mx-auto">
                                <div class="text-center">
                                    <p class="mb-2 text-black font-semibold">
                                        <!-- {{ selectedRoom ? (selectedRoom.start_time).slice(0,5) : '' }} -->
                                        <!-- no start time in selected Room -->
                                    </p>
                                    <p class="mb-2 text-black font-semibold">
                                        {{ selectedRoom ? selectedRoom.name : '' }}
                                    </p>
                                    <p class="mb-4 text-black font-semibold">
                                        Price : {{ selectedRoom ? selectedRoom.price_per_hour.toLocaleString() : '' }}
                                        MMKs
                                    </p>
                                </div>
                                <img class="w-[60%] mx-auto mb-6" src="../../../../../public/img/Video_light.png"
                                    alt="">
                                <button @click="btnClickedOpenRoom"
                                    class="bg-[#55EFC4] text-black text-center text-sm font-semibold w-full py-3 mb-2">
                                    Open Table
                                </button>
                                <button @click="confirmRoomBtnClicked"
                                    class="bg-[#55EFC4] text-black text-center text-sm font-semibold w-full py-3">
                                    Open Now
                                </button>

                            </div>
                        </div>
                    </div>
                    <div class="relative h-full" v-if="isOpenRoom.open_2 == true" id="open_room_2">
                        <div class="small-scrollbar overflow-y-auto h-[100vh] pt-8">
                            <div class="padding-section w-2/3 mx-auto ">

                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Customer Name
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="selectedCustomer"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option :value="customer" v-for="(customer, customerIndex) in customerList"
                                                :key="customerIndex"> {{ customer.name }} </option>
                                        </select>
                                        <button
                                            class="absolute -right-6 transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                            data-te-toggle="modal" data-te-target="#create_customer_modal"
                                            @click="handleClick">
                                            +
                                        </button>
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Type
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="type"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option value="null"> Free </option>
                                            <option value="package"> Package </option>
                                            <option value="endless_time"> Endless Time </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-4" v-show="this.type == 'package'">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Packages
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="selectedPackage" @change="getSelectedPackage()"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option v-for="pack in packageList" :value="pack" :key="pack">
                                                {{ pack.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Pre Deposit?
                                    </label>
                                    <input type="checkbox" v-model="isPreDeposit" class="rounded">
                                </div>
                                <div class="mb-4" v-if="isPreDeposit">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Deposit
                                    </label>
                                    <input type="text" placeholder="Deposit Amount" v-model="deposit"
                                        :disabled="!isPreDeposit"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <div class="mb-4" v-if="isPreDeposit">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Cash Account
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="selectedCashAccount" :disabled="!isPreDeposit"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option disabled selected> Select Cash Account </option>
                                            <option v-for="cashAccount in cashAccounts" :value="cashAccount"> {{
                                                cashAccount.name }} </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Deposit
                                    </label>
                                    <input type="text" placeholder="Deposit" v-model="deposit"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div> -->
                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Male
                                    </label>
                                    <input type="number" placeholder="Male" v-model="male"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Female
                                    </label>
                                    <input type="number" placeholder="Female" v-model="female"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <div class="mb-8">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Child
                                    </label>
                                    <input type="number" placeholder="Child" v-model="child"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <button @click="confirmRoomBtnClicked()"
                                    class="bg-[#55EFC4] text-black text-center text-sm font-semibold w-full py-3">
                                    Open Room
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isOpenRoom.detail" class="relative h-full">
                        <div class="flex justify-between padding-section border-b">
                            <div>
                                <p class="text-black text-xl" v-if="selectedRoom">
                                    {{ selectedRoom ? selectedRoom.name : '' }}
                                </p>
                            </div>
                            <div class="flex gap-x-3">
                                <button class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                    @click="btnClickedGetChangeableRoomList()" data-te-toggle="modal"
                                    data-te-target="#change_table_modal">
                                    <i class="far fa-random"></i>
                                </button>
                                <!-- <button @click="btnClickAddMenu()"
                                    class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                    data-te-toggle="modal" data-te-target="#add_menu_table_modal">
                                    <i class="far fa-cocktail"></i>
                                </button> -->
                                <!-- <a :href="'/pos/pos_order/'+selectedRoom?.id"><i class="far fa-cocktail"></i></a> -->
                                 <button @click="btnClickAddMenu()"
                                    class="transition duration-150 ease-in-out focus:outline-none focus:ring-0">
                                    <i class="far fa-cocktail"></i>
                                </button>
                                <button class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                    data-te-toggle="modal" data-te-target="#add_accessory_modal"
                                    @click="getAccessoryCategoryList()">
                                    <i class="far fa-plus-circle"></i>
                                </button>
                                <button class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                    data-te-toggle="modal" data-te-target="#add_service_modal"
                                    @click="btnClickAddService()">
                                    <i class="far fa-user-music"></i>
                                </button>
                                <!-- <button class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                    data-te-toggle="modal" data-te-target="#add_hour_modal">
                                    <i class="far fa-hourglass-half"></i>
                                </button> -->
                            </div>
                        </div>
                        <div class="small-scrollbar overflow-y-auto" style="height:calc(100% - 195px)">
                            <div class="padding-section border-b    " v-if="selectedRoom">
                                <div class="flex justify-between font-semibold mb-2">
                                    <p class="text-sm text-black" v-if="selectedRoom">
                                        Invoice Id
                                        {{ selectedRoom.invoice ? (selectedRoom.invoice.invoice_id ?
                                        selectedRoom.invoice.invoice_id : '')
                                        : '' }}

                                    </p>
                                    <p class="text-sm text-black font-semibold" v-if="selectedRoom">
                                        {{ selectedRoom ? selectedRoom.total_session_price : '' }}
                                        MMKs
                                    </p>
                                </div>
                                <div class="mb-2">
                                    <p class="px-2 py-0.5 bg-[#F19E51] text-white text-xs w-fit" v-if="selectedRoom">

                                        {{ selectedRoom.name ? selectedRoom.name : ''}}
                                    </p>
                                </div>
                                <div class="">
                                    <!-- <p class="text-sm text-black mb-2">
                                        Start Time : {{ selectedRoom.room_sessions.length > 0 ?
                                            selectedRoom.room_sessions[0].start_date : '' }}
                                    </p>
                                    <p class="text-sm text-black">
                                        End Time : {{ selectedRoom.room_sessions.length > 0 ?
                                            selectedRoom.room_sessions[0].end_date : '' }}
                                    </p> -->
                                </div>
                            </div>

                            <div class="padding-section border-b    ">
                                <div class="flex justify-between font-semibold mb-3">
                                    <p class="px-2 py-0.5 bg-[#F19E51] text-white text-xs w-fit">
                                        Menu Total
                                    </p>
                                    <p class="text-sm text-black font-semibold">
                                        {{ purchaseMenuList.length > 0 ? (purchaseMenuList[0].total).toLocaleString() :
                                        '0' }}
                                        MMks
                                    </p>
                                </div>
                                <div class=" grid grid-cols-10 gap-x-2 gap-y-3">
                                    <div v-for="(menu, index) in purchaseMenuList" class="contents" :key="index">

                                        <div v-for="menu2 in combinedMenuList" class="contents" :key="menu2">
                                            <p class=" col-span-4 text-sm">
                                                {{ menu2.menu.name }}
                                            </p>
                                            <p class=" col-span-1 text-center text-sm">
                                                {{ menu2.quantity }}
                                            </p>

                                            <!-- <select name="" id="" class="w-12  col-span-2">
                                                <option value="test">
                                                    {{ menu2.status }}
                                                </option>
                                            </select> -->
                                            <p :class="menu2.status == 'done' ? 'text-green-600 font-semibold' : 'text-gray-500'"
                                                class=" col-span-2 text-center text-xs pt-0.5">
                                                {{ menu2.status }}
                                            </p>
                                            <p class=" col-span-3 text-sm text-right">
                                                {{ (menu2.price).toLocaleString() }} MMKs
                                            </p>
                                        </div>


                                        <!-- <div v-for="menu2 in menu.order_items" class="contents" :key="menu2">
                                            <p class=" col-span-4 text-sm">
                                                {{ menu2.menu.name }}
                                            </p>
                                            <p class=" col-span-1 text-center text-sm">
                                                {{ menu2.quantity }}
                                            </p>
                                            <p :class="menu2.status == 'done' ? 'text-green-600 font-semibold' : 'text-gray-500'"
                                                class=" col-span-2 text-center text-xs pt-0.5">
                                                {{ menu2.status }}
                                            </p>
                                            <p class=" col-span-3 text-sm text-right">
                                                {{ (menu2.price).toLocaleString() }} MMKs
                                            </p>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- services -->
                            <div class="padding-section border-b" v-if="serviceList.length > 0">
                                <div class="flex justify-between font-semibold mb-3">
                                    <p class="px-2 py-0.5 bg-[#F19E51] text-white text-xs w-fit">
                                        Services
                                    </p>
                                    <p class="text-sm text-black font-semibold">
                                        {{ selectedRoom.total_service_value.toLocaleString() }} MMks
                                    </p>
                                </div>
                                <div class=" grid grid-cols-10 gap-x-2 gap-y-3">
                                    <div class="contents" v-for="(service,index) in serviceList" :key="index"
                                        :class="service.is_active == 1 ? 'text-black' : 'text-gray-400'">
                                        <div class=" col-span-3 text-sm">
                                            <button data-te-toggle="modal" data-te-target="#service_end_modal"
                                                @click="btnClickedEndService(service)">
                                                {{ service.service.name ? service.service.name :
                                                service.service.staff.name }}
                                            </button>
                                        </div>
                                        <!-- <p class=" col-span-3 text-sm" v-else>
                                                {{ service.service.staff.name }}
                                            </p> -->
                                        <p class=" col-span-3 text-center text-sm">
                                            {{ service.minutes }}
                                        </p>
                                        <!-- <p :class="menu2.status == 'done' ? 'text-green-600 font-semibold' : 'text-gray-500'"
                                                class=" col-span-2 text-center text-xs pt-0.5">
                                                {{ menu2.status }}
                                            </p> -->
                                        <p class=" col-span-4 text-sm text-right">
                                            {{ service.service_value.toLocaleString() }} MMKs
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- accessories -->
                            <div class="padding-section border-b    " v-if="accessoryListSidebar.length > 0">
                                <div class="flex justify-between font-semibold mb-3">
                                    <p class="px-2 py-0.5 bg-[#F19E51] text-white text-xs w-fit">
                                        Accessories
                                    </p>
                                    <p class="text-sm text-black font-semibold">
                                        {{ selectedRoom.total_accessory_value.toLocaleString() }} MMks
                                    </p>
                                </div>
                                <div class=" grid grid-cols-10 gap-x-2 gap-y-3">
                                    <div class="contents" v-for="(accessory,index) in accessoryListSidebar"
                                        :key="index">
                                        <div class=" col-span-3 text-sm">
                                            {{ accessory.accessory.name }}
                                        </div>
                                        <p class=" col-span-3 text-center text-sm">
                                            {{ accessory.quantity }}
                                        </p>
                                        <p class=" col-span-4 text-sm text-right">
                                            {{ (accessory.accessory.accessory_price.price *
                                            accessory.quantity).toLocaleString() }} MMKs
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="absolute bottom-0 border-t-2 border-gray-200 w-full padding-section">
                            <div class=" text-right pr-3 mb-3">
                                <p class="" v-if="selectedRoom && purchaseMenuList.length > 0">
                                    Total
                                    <!-- {{
                                        (selectedRoom ?
                                            (purchaseMenuList.length > 0 ?
                                                (
                                                    (selectedRoom.invoice.total_session_price ?
                                                        selectedRoom.invoice.total_session_price : 0)
                                                    +
                                                    (purchaseMenuList.length > 0 ? purchaseMenuList[0].total : 0)
                                                    - (selectedRoom.invoice.package ? selectedRoom.room_sessions[0].latest_invoice.package.package_discount : 0)
                                                ).toLocaleString()
                                                :
                                                (
                                                    (selectedRoom.invoice.total_session_price ?
                                                        selectedRoom.invoice.total_session_price : 0)
                                                    - (selectedRoom.invoice.package ? selectedRoom.room_sessions[0].latest_invoice.package.package_discount : 0)
                                                ).toLocaleString()
                                            )
                                            : 0
                                        )


                                    }} -->
                                    {{
                                    (selectedRoom ?
                                    (
                                    (purchaseMenuList.length > 0 ?
                                    (
                                    purchaseMenuList[0].total - (selectedRoom.invoice.package ?
                                    selectedRoom.room_sessions[0].latest_invoice.package.package_discount : 0)
                                    )
                                    :
                                    (
                                    selectedRoom.invoice.package ?
                                    selectedRoom.room_sessions[0].latest_invoice.package.package_discount : 0
                                    )
                                    )
                                    + selectedRoom.total_service_value+selectedRoom.total_accessory_value
                                    ).toLocaleString()

                                    : 0 )


                                    }}
                                    MMKs
                                </p>
                            </div>
                            <div class="">
                                <button @click="btnClickedDoneSession()"
                                    class="bg-[#55EFC4] text-black text-center text-sm font-semibold w-full py-3">
                                    Done Session
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- invoice right sidebar -->
                    <div v-if="isOpenRoom.invoice" class="relative h-full">
                        <div class="flex justify-between padding-section border-b">
                            <button @click="btnBackToDetail()">
                                <i class="far fa-chevron-left"></i>
                            </button>
                            <div>
                                <p class="text-black text-lg">
                                    Invoice
                                </p>
                            </div>
                            <div></div>
                        </div>
                        <div class="small-scrollbar overflow-y-auto" style="height:calc(100% - 329px)">
                            <div class="padding-section w-2/3 mx-auto ">
                                <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Discount Type
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="discount_type" @change="getRoomDiscount"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option value="fix_amount"> Fix Ammount </option>
                                            <option value="percentage"> Percentage </option>
                                            <option value="customer_level"
                                                :disabled="roomSessionData.customer_level == 'no customer level'">
                                                Customer Level </option>
                                            <option value="birthday_discount"
                                                v-if="roomSessionData ? roomSessionData.is_birthday : ''"> Birthday
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-4" v-show="discount_type == 'birthday_discount'">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Birthday Disount
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="birthday_discount"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0"
                                            @change="birthdayDiscountSelectChanged">
                                            <option v-for="bd in birthdayDiscountList" :value="bd" :key="bd"> {{ bd.name
                                                }} </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mb-4"
                                    v-show="discount_type != 'customer_level' && discount_type != 'birthday_discount'">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Discount
                                    </label>
                                    <input type="number" placeholder="Discount" v-model="printInvoiceData.discount"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <!-- <div class="mb-4">
                                    <label for="" class="block text-sm text-black mb-3">
                                        Payment Method
                                    </label>
                                    <div class="relative">
                                        <select name="" id="" v-model="selectedPaymentMethod"
                                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                            <option value="bank"> Bank </option>
                                            <option value="cash" selected> Cash </option>
                                        </select>
                                    </div>
                                </div> -->
                                <div class="mb-4" v-if="roomSessionData.is_service == 1">
                                    <label for="" class="label-form mb-3">
                                        Service End Date
                                    </label>
                                    <input type="datetime-local" placeholder="End Date" v-model="serviceEndDate"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                </div>
                                <div class="mb-4">
                                    <div class="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]">
                                        <input class="input-check-pos" type="checkbox" v-model="printInvoiceData.isTax"
                                            @click="btnClickedTax()" value="" id="tax" />
                                        <label class="inline-block pl-[0.15rem] hover:cursor-pointer" for="tax">
                                            Tax
                                        </label>
                                    </div>
                                    <input type="number" v-show="printInvoiceData.isTax" placeholder="Tax" v-model="selectedTaxPercent"
                                    @input="btnClickedTax()"
                                        class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0 mt-2">
                                </div>
                                <div class="mb-4">
                                    <div class="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]">
                                        <input class="input-check-pos" type="checkbox"
                                            @click="btnClickedServiceCharge()" v-model="printInvoiceData.service_charge"
                                            value="" id="service" />
                                        <label class="inline-block pl-[0.15rem] hover:cursor-pointer" for="service">
                                            Service Charges
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="absolute bottom-0 border-t-2 border-gray-200 w-full padding-section !pt-3">
                            <div v-if="isPackage" class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Package Price
                                </p>
                                <p class=" w-28">
                                    {{ selectedRoom.room_sessions[0].invoice.package.name }}
                                </p>
                            </div>
                            <div v-if="!isPackage" class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Room
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.room ? printInvoiceData.room.toLocaleString() : 0 }} MMKs
                                </p>
                            </div>
                            <div class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Food
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.food ? printInvoiceData.food.toLocaleString() : 0 }} MMks
                                </p>
                            </div>
                            <div class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Service Charge
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.service_charge == true ? (printInvoiceData.service_tax ?
                                    printInvoiceData.service_tax.toLocaleString() :
                                    0) : 0 }} MMKs
                                </p>
                            </div>
                            <div class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Tax
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.isTax == true ? (printInvoiceData.tax ?
                                    printInvoiceData.tax.toLocaleString() :
                                    0) : 0 }} MMKs
                                </p>
                            </div>
                            <div class="text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Food Discount
                                </p>
                                <p class="w-28">
                                    {{ foodDiscount > 0 ? '- ' : '' }} {{ foodDiscount }}
                                </p>
                            </div>
                            <div v-if="isPackage" class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Package Discount
                                </p>
                                <p class=" w-28">
                                    {{ selectedRoom.room_sessions[0].invoice.package.package_discount > 0 ? '- ' : '' }}
                                    {{ selectedRoom.room_sessions[0].invoice.package.package_discount }}
                                </p>
                            </div>
                            <div v-show="discount_type != 'customer_level'"
                                class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Discount
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.discount > 0 ? '- ' : '' }} {{ printInvoiceData.discount }} {{
                                    this.discount_type == 'percentage' ? '%' : 'MMKs' }}
                                </p>
                            </div>
                            <div v-show="discount_type == 'customer_level'"
                                class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Customer Discount
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.customer_discount > 0 ? '- ' : '' }} {{
                                    printInvoiceData.customer_discount }} MMKs
                                </p>
                            </div>
                            <div v-show="roomSessionData.is_service == 1"
                                class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Service Price
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.service_total_value.toLocaleString() }} MMKs
                                </p>
                            </div>
                            <div v-show="roomSessionData.total_accessory_value > 0"
                                class=" text-sm text-right flex gap-x-2 justify-end pr-2 mb-2">
                                <p>
                                    Accessories Price
                                </p>
                                <p class=" w-28">
                                    {{ printInvoiceData.accessory_total_value.toLocaleString() }} MMKs
                                </p>
                            </div>
                            <div class=" text-right pr-3 mb-3">
                                <p class="font-semibold">
                                    Total &nbsp;
                                    {{ 
                                    // ( (printInvoiceData.total ? printInvoiceData.total : 0)
                                    // + (printInvoiceData.service_charge == true ? (printInvoiceData.service_tax ?
                                    // printInvoiceData.service_tax : 0) : 0)
                                    // + (printInvoiceData.isTax == true ? (printInvoiceData.tax ? printInvoiceData.tax :
                                    // 0) : 0)
                                    // - foodDiscount
                                    // ).toLocaleString()
                                    (printInvoiceData.total ? printInvoiceData.total : 0).toLocaleString()
                                    }} MMKs
                                </p>
                            </div>
                            <div class="flex">
                                <button @click="btnClickedEndRoom()"
                                    class="bg-[#55EFC4] text-black text-center text-sm font-semibold w-full py-3">
                                    Print Invoice
                                </button>
<div style="display: none">
    <div ref="receiptRef" v-if="invoiceData" class="receipt-container">
        <header>
            <div class="header-top">
                <h1 class="brand-name">MegaZ</h1>
            </div>

            <div class="meta-grid">
                <div class="meta-left">
                    <p>Voucher No:</p>
                    <p>{{ invoiceData.invoice_no }}</p>
                    <p style="margin-top: 8px">
                        Table: {{ invoiceData.entity_detail?.name || '-' }}
                    </p>
                    <p class="italic">PAID</p>
                </div>
                <div class="meta-right">
                    <p>Date: {{ formattedDate }}</p>
                    <p>{{ formattedTime }}</p>
                    <p style="margin-top: 8px">
                        User: {{ invoiceData.user }}
                    </p>
                </div>
            </div>
        </header>

        <hr class="solid-thick" />

        <section class="items">
            <div v-for="(group, index) in mappedItems" :key="index">
                <div class="category">{{ group.category }}</div>
                <div v-for="(item, i) in group.list" :key="i" class="item-row">
                    <span>{{ item.name }}</span>
                    <span>{{ item.qty }} x {{ item.price.toLocaleString() }}</span>
                    <span>{{ (item.qty * item.price).toLocaleString() }}</span>
                </div>
            </div>
        </section>

        <hr class="solid-thick" />

        <section class="totals">
            <div class="total-row">
                <span class="bold">Total Qty: {{ totalQuantity }}</span>
            </div>

            <div v-for="(total, index) in summaryRows" :key="index"
                 class="total-row align-right" :class="{ bold: total.isBold }">
                <span>{{ total.label }}</span>
                <span>{{ total.value }}</span>
            </div>
        </section>

        <footer class="center footer-info">
            <p class="bold">Thank you for visiting!</p>
            <p class="italic">Print At: {{ new Date().toLocaleString() }}</p>
        </footer>
    </div>
</div>
                            </div>
                        </div>
                    </div>


                    <!-- <div v-if="isOpenRoom.is_package == true" class="relative h-full">
                        <div class="flex justify-center padding-section ">

                            <div>
                                <p class="text-black text-lg">
                                    Confirm Menu
                                </p>
                            </div>
                        </div>
                        <div class="small-scrollbar overflow-y-auto" style="height:calc(100% - 329px)">
                            <div class="padding-section ">
                                <div class="table-container px-2">
                                    <table class=" w-full">
                                        <thead class="">
                                            <tr class="border-b">
                                                <th scope="col" class="text-left   py-4">
                                                    Menu
                                                </th>
                                                <th scope="col" class="text-left   py-4">
                                                    Area
                                                </th>
                                                <th scope="col" class="text-left   py-4">
                                                    Qty
                                                </th>
                                                <th scope="col" class="text-left   py-4">
                                                    Price
                                                </th>
                                                <th scope="col" class="text-left   py-4">

                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="" v-for="(pm,index) in packageMenuList" :key=index>
                                                <td class=" py-4 text-sm  ">
                                                    {{ pm.name }}
                                                </td>
                                                <td class=" py-4 text-sm  ">
                                                    <select name="" :class="pm.is_package == 0 ? 'hidden' : ''"
                                                        class="text-xs pl-0 border-0 focus:shadow-none focus:outline-none focus:ring-0 select-box area-select-box !pr-6"
                                                        placeholder="Select Area" @change="packageCookingAreaChange(area,index)" v-model="pm.area_id">
                                                        <option disabled selected>Select Area</option>
                                                        <option v-for="(area, index) in pm.areas" :key="index"
                                                            :value="area.id" class="">
                                                            {{ area.name }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class=" py-4 text-sm  ">
                                                    {{ pm.quantity }}
                                                </td>
                                                <td class=" py-4 text-sm  ">
                                                    {{ (pm.original_price - pm.discount_value) * pm.quantity  }}
                                                </td>
                                                <td class=" py-4 text-sm  text-center">
                                                    <button
                                                        @click="removePackageMenu(index)">
                                                        <i class="fal fa-times  pr-3"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                        <div class="absolute bottom-0 border-t-2 border-gray-200 w-full padding-section !pt-3">
                            <div>
                                <button class="w-full text-center mb-3 font-semibold text-sm"
                                data-te-toggle="modal" data-te-target="#add_package_menu_modal">
                                    Add More Menu
                                </button>
                            </div>
                            <div class="">
                                <button @click="createRoomForPackage()"
                                    class="bg-[#55EFC4] text-gray-700 text-center text-sm font-semibold w-full py-3">
                                    Confirm Menu
                                </button>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="relative block h-full">
                        <div class="w-full h-full flex justify-center flex-col">
                            <div class="w-2/3 mx-auto">
                                <div class="text-center">
                                    <p class="mb-4 text-black font-semibold">
                                        Select A Room
                                    </p>
                                </div>
                                <img class="w-[60%] mx-auto mb-6" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnjfjQ0p-BZt5Vb6KhcdHPeC4hBxiKEYXxMw&s" alt="">

                            </div>
                        </div>
                    </div> -->
                </div>
            </div>


        </div>


        <!-- add Menu modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="add_menu_table_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            Add Menu
                        </p>
                        <button type="button" id="closeAddMenuTableModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <multiselect v-model="selectedMenu" :options="menuList" :close-on-select="true"
                                class=" h-10" @select="selectedMenuChange()" :clear-on-select="false"
                                :preserve-search="true" placeholder="Select Menu" label="name"
                                :custom-label="nameWithPrice" track-by="id" :preselect-first="false"></multiselect>


                            <!-- <select name="" id="" placeholder="Menu" v-model="selectedMenu" @change="selectedMenuChange()"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                <option :value="menu" v-for="(menu, index) in menuList" :key="index">{{ menu.name }}</option>
                            </select> -->

                        </div>
                        <!-- <div class="mb-4">
                            <select name="" id="" placeholder="Menu" v-model="selectedMenuArea"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                <option :value="area" v-for="(area, index) in menuAreaList" :key="index">{{ area.name }}</option>
                            </select>
                        </div> -->
                        <div class="mb-4">
                            <label class="inline-flex items-center cursor-pointer">
                                <input type="checkbox" v-model="hasSellingExtras" class="sr-only peer" />
                                <div
                                    class="w-5 h-5 bg-gray-300 rounded-sm peer-checked:bg-green-500 peer-focus:ring-2 peer-focus:ring-blue-400 flex items-center justify-center transition-colors">
                                    <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24">
                                        <path d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </label>
                            <span class="text-sm mx-2"> Add Extras? </span>
                        </div>

                        <div class="mb-4" v-if="hasSellingExtras">
                            <multiselect v-model="selectedTableSellingExtras" :options="tableSellingExtras"
                                :close-on-select="false" class=" h-10" :multiple="true" :clear-on-select="false"
                                :preserve-search="true" placeholder="Select Extras" :custom-label="sellingExtraName"
                                track-by="id" :preselect-first="false"></multiselect>
                        </div>

                        <div class="mb-4">
                            <input type="number" placeholder="Qty" v-model="menuQuantity"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                        </div>

                        <div class="mb-4">
                            <div class="flex space-x-4 items-center justify-center">
                                <div class="w-3/4">
                                    <multiselect v-model="selectedTableRemark" :options="remarks"
                                        :close-on-select="true" class=" h-10" :clear-on-select="false"
                                        :preserve-search="true" placeholder="Remark" label="name" track-by="id"
                                        :preselect-first="false"></multiselect>
                                </div>
                                <div class="w-1/4 text-center h-8 pt-1 text-lg">
                                    <button class="transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                                        data-te-toggle="modal" data-te-target="#add_remark_modal">
                                        <i class="far fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <!-- <div>
                            <textarea v-model="remark"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0"
                                name="" id="" cols="30" rows="10" placeholder="Remark"></textarea>
                        </div> -->
                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnConfirmAddMenu" class="pos-add-btn focus:outline-none focus:ring-0 ">
                            Add Menu
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- add Package Menu modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="add_package_menu_table_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true"
            role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            Add Package Menu
                        </p>
                        <button type="button" id="closeAddPackageMenuTableModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <select name="" id="" placeholder="Menu" v-model="selectedMenuForPackage"
                                @change="selectedPackageMenuChange()"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                <option :value="menu" v-for="(menu, index) in menuList" :key="index">{{ menu.name }}
                                </option>
                            </select>
                        </div>
                        <!-- <div class="mb-4">
                            <select name="" id="" placeholder="Menu" v-model="selectedMenuAreaForPackage"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                <option :value="area" v-for="(area, index) in menuAreaListForPackage" :key="index">{{ area.name }}</option>
                            </select>
                        </div> -->
                        <div class="mb-4">
                            <input type="text" placeholder="Qty" v-model="menuQuantityForPackage"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                        </div>
                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnConfirmAddPackageMenu()"
                            class="pos-add-btn focus:outline-none focus:ring-0 ">
                            Add Menu
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- change room modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="change_table_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            Change Room
                        </p>
                        <button type="button" id="closeChangeTableModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <select name="" id="" placeholder="Room" v-model="change_room"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                                <option :value="changeableRoom" :key="index"
                                    v-for="(changeableRoom, index) in changeableRoomList">{{ changeableRoom.name }}
                                </option>
                            </select>
                        </div>

                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnClickedChangeRoom()" class="pos-add-btn focus:outline-none focus:ring-0 ">
                            Change
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <!-- add Service modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="add_service_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            Add Service
                        </p>
                        <button type="button" id="closeServiceModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                Service Category
                            </label>
                            <select name="" id="" v-model="selectedServiceCategory" class="input-ui"
                                @change="serviceCategoryChange()">
                                <option :value="service" v-for="(service, index) in serviceCategoryList" :key="index">{{
                                    service.name }}</option>
                            </select>
                        </div>
                        <div class="mb-4" v-if="selectedServiceCategory ? selectedServiceCategory.name == 'Lady' : ''">
                            <label for="" class="label-form mb-3">
                                Lady
                            </label>
                            <select name="" id="" v-model="selectedLady" class="input-ui">
                                <option :value="lady" v-for="(lady, index) in ladyList" :key="index">{{
                                    lady.staff ? lady.staff.name : '' }}</option>
                            </select>
                        </div>
                        <div class="mb-4" v-if="selectedServiceCategory ? selectedServiceCategory.name == 'DJ' : ''">
                            <label for="" class="label-form mb-3">
                                DJ
                            </label>
                            <select name="" id="" v-model="selectedDj" class="input-ui">
                                <option :value="dj" v-for="(dj, index) in djList" :key="index">{{
                                    dj.name }}</option>
                            </select>
                        </div>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                Start Date
                            </label>
                            <input type="datetime-local" placeholder="Qty" v-model="selectedServiceStartTime"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                        </div>
                        <div class="mb-4">
                            <label for="" class="block text-sm text-black mb-3">
                                Remark
                            </label>
                            <textarea v-model="serviceRemark"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0"
                                name="" id="" cols="30" rows="10" placeholder="Remark"></textarea>
                        </div>
                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnConfirmAddService()" class="pos-add-btn focus:outline-none focus:ring-0 ">
                            Add Service
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- end Service modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="service_end_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            End Service
                        </p>
                        <button type="button" id="closeEndServiceModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                End Date
                            </label>
                            <input type="datetime-local" placeholder="End Date" v-model="selectedServiceEndTime"
                                class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                        </div>
                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnConfirmEndService()" class="pos-add-btn focus:outline-none focus:ring-0 ">
                            End Service
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <!-- add accessory modal -->
        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="add_accessory_modal" tabindex="-1" aria-labelledby="addAccessoryModalLabel" aria-modal="true"
            role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative  p-4">
                        <p class="text-xl w-full text-center">
                            Add Accessory
                        </p>
                        <button type="button" id="closeAccessoryModal"
                            class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                            aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-16 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                Accessory Category
                            </label>
                            <select name="" id="" v-model="selectedAccessoryCategory" class="input-ui"
                                @change="accessoryCategoryChange()">
                                <option :value="accessory" v-for="(accessory, index) in accessoryCategoryList"
                                    :key="index">{{
                                    accessory.name }}</option>
                            </select>
                        </div>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                Accessory
                            </label>
                            <select name="" id="" v-model="selectedAccessory" class="input-ui">
                                <option :value="accessory" v-for="(accessory, index) in accessoryList" :key="index">
                                    {{ accessory.name }}</option>
                            </select>
                        </div>
                        <div class="mb-4">
                            <label for="" class="label-form mb-3">
                                Quantity
                            </label>
                            <input type="number" v-model="selectedAccessoryQuantity" class="input-ui mb-2">
                        </div>
                    </div>

                    <div class="flex justify-center px-12 mb-6">
                        <button @click="btnConfirmAddAccessory()" class="pos-add-btn focus:outline-none focus:ring-0 ">
                            Add Service
                        </button>
                    </div>
                </div>
            </div>
        </div>



    </div>

    <div data-te-modal-init
        class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="add_remark_modal" tabindex="-1" aria-labelledby="addMenuModalLabel" aria-modal="true"
        role="dialog">
        <div data-te-modal-dialog-ref
            class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
            <div
                class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                <div class="relative  p-4">
                    <p class="text-xl w-full text-center">
                        New Remark
                    </p>
                    <button type="button" id="closeAddPackageMenuTableModal"
                        class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                        aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="h-5 w-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div class="relative px-16 py-4" data-te-modal-body-ref>
                    <div class="mb-4">
                        <input type="text" placeholder="Remark" v-model="newRemarkText" class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                    </div>
                </div>

                <div class="flex justify-center px-12 mb-6">
                    <button @click="addNewRemarkBtnClicked()" class="pos-add-btn focus:outline-none focus:ring-0 " data-te-modal-dismiss>
                        Add Remark
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Modal, Ripple, Select, Datepicker, initTE, Input } from "tw-elements";
    import { getApiData, postApiData, deleteApiData } from '../../../utilities/ajax-helpers';
    import { mapGetters } from "vuex";
    import { getCurrentTime, getCurretDateTime } from "../../../utilities/datetime-helpers";
    import Multiselect from 'vue-multiselect';
    import PosLoadingBtn from "../Common/PosLoadingBtn.vue";
    import { useVueToPrint } from "vue-to-print";
    import { ref } from "vue";

    export default {
        components:{
            Multiselect,
            PosLoadingBtn,
        },

        name:'PosTableComponent',
        props:{
            tableAreaId:{
                type: Number,
                required: true
            },
            area:{
                type: Object,
                required: true
            },
            sellingExtras: {
                type: Array,
                required: true
            },
            remarks: {
                type: Array,
                required: true
            }
        },
        emits: ['callParent'],
        // props: ['tableAreaId'],

        setup() {
        const receiptRef = ref(null);
        const { handlePrint } = useVueToPrint({
            content: () => receiptRef.value,
            documentTitle: "Receipt",
        });

        return { receiptRef, handlePrint };
        },
        data() {
            return {
                roomList:[],
                area_Id :null,
                isOpenRoom:{
                    open_1: false,
                    open_2: false,
                    detail: false,
                    invoice: false,
                    is_package:false,
                },
                selectedRoom: null,
                selectedRoomId: null,

                //customer data
                name: null,
                ph_number: null,
                email: null,
                genderList: [],
                date: null,
                duration: null,
                selectedDivision: null,
                divisionList: null,
                selectedTownship: null,
                townshipList: null,
                address_name: null,
                address: null,
                selectedGender: null,


                // open_2's data
                customerList:[],
                packageList:[],

                selectedCustomer:null,
                invoice_date:null,
                type: null,
                selectedPackage:null,
                isPreDeposit: false,
                deposit:null,
                duration:null,
                male:null,
                female:null,
                child:null,

                purchaseMenuList: [],
                foodDiscount: 0,
                selectedRoomIndex: null,
                printInvoiceData: {
                    room: 0,
                    food: 0,
                    service_tax: 0,
                    service_charge: false,
                    tax: 0,
                    isTax: false,
                    discount: 0,
                    tatalPrice: 0,
                    package_discount:0,
                    customer_discount:0,
                    percent_discount_amount:0,
                    service_total_value:0,
                    accessory_total_value:0,
                },
                room_discount: null,
                birthday_discount: null,
                orderList: [],
                orderItemsPrice: null,
                selectedPaymentMethod: 'cash',
                change: null,
                paid_amount: null,
                isActive: true,

                packageMenuList:[],
                menuAreaListForPackage:[],
                selectedMenuForPackage:null,
                selectedMenuAreaForPackage:null,
                menuQuantityForPackage:null,
                is_menu_discount:0,
                food_total_package:0,
                total_package_menu_price:0,
                package_total:0,

                // create menu , add hour , change room
                invoiceId: null,
                selectedMenu: null,
                menuAreaList:[],
                selectedMenuArea:null,
                menuQuantity: null,
                remark: null,
                menuPrice: null,
                testroom: null,
                sessionDuration: null,
                changeableRoomList: [],
                change_room: null,

                // doneSession
                roomDiscountList: null,
                birthdayDiscountList: null,
                isPackage: false,
                packagePrice: null,
                discount_type: null,
                isShowDiscount: true,

                // rooftop
                tableList: [],

                // currentTime: getCurretDateTime(),
                roomSessionData: null,

                roomEndTime:null,
                authUser:null,
                isCashier :false,

                // add service
                serviceCategoryList:[],
                ladyList:[],
                djList:[],

                selectedServiceCategory:null,
                selectedLady:null,
                selectedDj:null,
                selectedServiceQuantity:null,
                serviceRemark:null,
                selectedServiceStartTime:null,
                serviceEnd :null,
                selectedServiceEndTime:null,
                serviceList:[], // use in right sidebar

                serviceEndDate:null,


                // add accessory
                accessoryListSidebar:[],
                accessoryCategoryList:[],
                accessoryList:[],

                selectedAccessoryCategory:null,
                selectedAccessory:null,
                selectedAccessoryQuantity:null,

                cashAccounts: [],
                selectedCashAccount: null,

                currentTime: getCurretDateTime(),
                isShowSidebar:false,
                entityType:null,

                tableSellingExtras: [],
                selectedTableSellingExtras: [],
                hasSellingExtras: false,

                tableRemarks: [],
                selectedTableRemark: null,

                newRemarkText: null,
                selectedTaxPercent: 5,

                foodOrderPanelShown: false,
                menuCategoryList: [],
                selectedMenuCategory: null,
                menuList: [],
                menuSearchQuery: '',
                menuLoading: false,
                cartMenus: [],
                cartMenusPriceTotal: 0,
                cartMenusFocTotal: 0,
                entityDetails: null,
                menuOrderBtnLoading: false,
                invoiceData: null,

                isModalOpen: false,
                activeMenuIndex: null,
                modalRemarkText: ''
            };
        },

        methods: {
            ...mapGetters(['getToken']),

            openRemarkModal(index) {
        this.activeMenuIndex = index;
        this.modalRemarkText = this.cartMenus[index].remark || '';
        this.isModalOpen = true;
    },
    closeRemarkModal() {
        this.isModalOpen = false;
        this.activeMenuIndex = null;
        this.modalRemarkText = '';
    },
    saveRemark() {
        if (this.activeMenuIndex !== null) {
            this.cartMenus[this.activeMenuIndex].remark = this.modalRemarkText;
        }
        this.closeRemarkModal();
    },

            addNewRemarkBtnClicked(){
                if(!this.newRemarkText){
                    this.showToastMessage('Please provide remark');
                    return;
                }
                let formData = new FormData();
                formData.append('name',this.newRemarkText);
                postApiData({url: `/api/remarks`, form_data: formData, token: this.getToken()})
                .then((response)=>{
                    if(response.success){
                        this.showToastMessage('New remark created', 'success', 'Success');
                        this.selectedTableRemark = response.data;
                        this.tableRemarks.push(response.data);
                        this.newRemarkText = null;
                    }
                });
            },

            showToastMessage(message, type="warn", title="Input Validation") {
                this.$notify({
                    title: `${title}`,
                    text: `${message}`,
                    type: `${type}`
                });
            },

            handleClick() {
                this.$emit('callParent');
            },
            async getTableList(){
                if(this.area.area_type.type == 'bar_and_restaurant'){
                    const response = await getApiData({ url: '/api/areas/' + this.area.id + '/entities' , token: this.getToken()});
                    if(response.data){
                        this.roomList = response.data;
                        console.log('get table list')
                        this.entityType = response.data[0].entity_type;
                    }
                }
            },
            async homeGetTableList(id){
                const response = await getApiData({ url: '/api/areas/' + id + '/entities' , token: this.getToken()});
                if(response.data){
                    this.roomList = response.data;
                    console.log('get home table list')
                }
            },
            async btnClickedIsOpenRoom(room , roomIndex) {
                this.tableSellingExtras = this.sellingExtras;
                this.tableRemarks = this.remarks;
                this.isShowSidebar = true;
                this.selectedRoom = null;
                this.selectedRoomId = room.id;
                this.getPurchaseMenuList();
                console.log('btnClickedIsOpenRoom',this.roomList[roomIndex].is_active)
                // this.getSelectedRoom();
                if (this.roomList[roomIndex].is_active == 1) {
                    this.isOpenRoomStep('detail');
                    const response = await getApiData({ url: '/api/entities/'+ this.selectedRoomId, token: this.getToken() });
                    console.log("Open Room");
                    
                    if (response.data) {
                        this.entityDetails = response.data;
                        this.selectedRoom = response.data;
                        this.purchaseMenuList = response.data.invoice.orders
                        this.serviceList = response.data.services;
                        this.accessoryListSidebar = response.data.invoice_accessories;
                        this.getMenuCategoryList();
                    }
                }
                else {
                    this.selectedRoom = this.roomList[roomIndex];
                    this.isOpenRoomStep('open_1');
                };
            },

            btnClickedOpenRoom() {
                this.isOpenRoomStep('open_2');
                // this.clearOpenRoomForm();
                this.isPackage = false;
                this.getCustomerList();
                this.selectedCustomer = null;
                this.type = null;
                this.isPreDeposit = false;
                this.deposit = null;
                this.selectedCashAccount = null;
                this.male = null;
                this.female = null;
                this.child = null;
            },

            // step 2's methods
            async getCustomerList() {
                const response = await getApiData({ url: '/api/customers', token: this.getToken() });
                if (response.data) {
                    this.customerList = response.data;
                }
            },
            async getPackageList(time) {
                const response = await getApiData({ url: '/api/packages?date='+time, token: this.getToken() });
                if (response.data) {
                    this.packageList = response.data.data;
                }
            },
            getSelectedPackage(){
                // this.packageMenuList = this.selectedPackage;
            },
            confirmRoomBtnClicked() {
                this.getPurchaseMenuList();
                if(this.type == 'package' && this.selectedPackage){
                    this.isOpenRoomStep('is_package');
                    let menuOfselectedPackage = this.selectedPackage.menu_packages;
                    menuOfselectedPackage.forEach((packageMenu)=>{
                        let is_dis_menu_price = 0;
                        this.food_total_package += (packageMenu.menu.prices[0].price - is_dis_menu_price) * packageMenu.quantity;
                        this.packageMenuList.push({
                            quantity : packageMenu.quantity,
                            name : packageMenu.menu.name,
                            original_price : packageMenu.menu.prices[0].price,
                            discount_value: is_dis_menu_price,
                            menu_id : packageMenu.menu_id,
                            is_package : 1,
                            area_id: null,
                            areas : packageMenu.menu.areas
                        });
                    });
                    console.log('package')
                }
                else{
                    this.createRoom();
                }
            },
            async selectedPackageMenuChange() {
                const response = await getApiData({ url: '/api/menus/' + this.selectedMenuForPackage.id + '/areas', token: this.getToken() });
                if (response.data) {
                    this.menuAreaListForPackage = response.data.areas;
                }
            },

            btnConfirmAddPackageMenu() {
                this.addPackageMenu();
            },
            packageCookingAreaChange(area,index){
                // this.packageMenuList[index].area_id = area.id;
                console.log(area)
            },
            async addPackageMenu() {
                if(this.selectedMenuForPackage.menu_service_discounts.length > 0){
                    this.is_menu_discount = this.selectedMenuForPackage.menu_service_discounts[0].discount_price
                }
                else{
                    this.is_menu_discount = 0
                }

                this.packageMenuList.push({
                    quantity: this.menuQuantityForPackage,
                    name: this.selectedMenuForPackage.name,
                    original_price:this.selectedMenuForPackage.prices[0].price,
                    menu_id : this.selectedMenuForPackage.prices[0].menu_id,
                    discount_value: this.is_menu_discount,
                    is_package : 0,
                    // area_id: this.selectedMenuAreaForPackage.id
                });
                this.food_total_package += (this.selectedMenuForPackage.prices[0].price - this.is_menu_discount) * this.menuQuantityForPackage;
                this.selectedMenu = null
                this.menuAreaListForPackage = []
                this.selectedMenuAreaForPackage = null;
                this.menuQuantityForPackage = null;
            },
            removePackageMenu(index){

                this.food_total_package -= (this.packageMenuList[index].original_price - this.packageMenuList[index].discount_value) * this.packageMenuList[index].quantity;
                this.packageMenuList.splice(index, 1);
            },

            createRoomForPackage(){

                // this.packageMenuList.forEach((packageMenu)=>{
                //     this.total_package_menu_price += (packageMenu.original_price - packageMenu.discount_value ) * packageMenu.quantity;
                // });
                let packageActualTotal = this.food_total_package + (this.selectedPackage.session_price * this.selectedPackage.pay_session) - this.selectedPackage.package_discount;
                if(packageActualTotal < this.selectedPackage.price){
                    this.$notify({
                        title: `Not valid`,
                        text: 'Your Total is Lower than Package Price',
                        type: "warn"
                    });
                }
                else{
                    this.filterMenuForData();
                    this.createRoom();
                }
            },

            async createRoom() {
                // if(this.isPreDeposit && !this.deposit && this.selectedCashAccount){
                //     this.showToastMessage(`deposit amount or cash account`);
                //     return;
                // }
                let nullData = "";
                let formData = new FormData();
                // formData.append('entity_id', this.selectedRoom.id);
                if(this.selectedCustomer){
                    formData.append('customer_id', this.selectedCustomer.id);
                }
                else{
                    formData.append('customer_id', nullData);
                }
                if (this.type == 'package') {
                    formData.append('package_id', this.selectedPackage.id);
                    formData.append('orders', JSON.stringify(this.packageMenuList));
                }
                formData.append('type', this.type);
                let isDeposit = (this.isPreDeposit)? 1: 0;
                formData.append('is_deposit', isDeposit);
                if(this.deposit){
                    formData.append('deposit', this.deposit);
                }
                if(this.selectedCashAccount){
                    formData.append('cash_account_id', this.selectedCashAccount.id);
                    formData.append('account_id', this.selectedCustomer.account_id);
                }
                if (this.female > 0) {
                    formData.append('female', +this.female);
                }
                if (this.male > 0) {
                    formData.append('male', +this.male);
                }
                if (this.child > 0) {
                    formData.append('child', +this.child);
                }
                formData.append('entity_type', this.entityType);
                formData.append('entity_id', this.selectedRoom.id);
                let response = await postApiData({ url: '/api/entities/start', form_data: formData, token: this.getToken() });
                if (response.success) {
                    this.getTableList();
                    this.getSelectedRoom();
                    this.isOpenRoomStep('detail');//for right side bar ui

                    if (this.selectedRoom) {
                        if (this.selectedRoom.invoice.orders.length < 1) {
                            this.purchaseMenuList = [];
                        }
                        this.getPurchaseMenuList();
                    }
                    this.food_total_package = 0 //total price of package menu and add more menu reset
                    console.log("success")
                    // window.location.reload()
                }
                else {
                    console.log('some errors occur')
                }
            },
            async getPurchaseMenuList() {
                const response = await getApiData({ url: '/api/entities/' + this.selectedRoomId, token: this.getToken() });
                console.log("Purchase Menu");
                
                if (response.data) {
                    this.entityDetails = response.data;
                    if (response.data.invoice) {
                        this.purchaseMenuList = response.data.invoice.orders;
                        if (response.data.invoice.orders.length > 0) {
                            if (response.data.invoice.orders[0]) {
                                this.foodDiscount = response.data.invoice.orders[0].total_discount_price
                            }
                        }
                        this.printInvoiceData.food = response.data.invoice.order.order_sub_total;
                        this.printInvoiceData.total = response.data.invoice.sub_total;
                    }
                    this.getMenuCategoryList();
                }
            },
            async getSelectedRoom() {
                const response = await getApiData({ url: '/api/entities/' + this.selectedRoomId, token: this.getToken() });
                console.log("Selected Room");
                
                if (response.data) {
                    this.selectedRoom = response.data;
                    this.purchaseMenuList = response.data.invoice.orders;
                    this.serviceList = response.data.services;
                    this.accessoryListSidebar = response.data.invoice_accessories;
                    console.log('get selected room ' + this.accessoryListSidebar)
                }
            },



            //invoice or done
            btnBackToDetail() {
                this.isOpenRoomStep('detail');
            },
            btnClickedDoneSession() {
                this.doneSession();
                this.getPurchaseMenuList();
                this.discount_type = null;
            },

            filterMenuForData(){
                this.packageMenuList.forEach(om => {
                    delete om.name;
                    delete om.areas;
                    console.log('hello = ' + om.name);
                });

            },
            async doneSession() {
                let formData = new FormData();
                let roomSessions = [];
                formData.append('invoice_id', this.selectedRoom.invoice.invoice_id);
                formData.append('entity_type', this.entityType);
                formData.append('entity_id',this.selectedRoom.entity_id);
                let response = await postApiData({ url: '/api/room_done', form_data: formData, token: this.getToken() });
                if (response.success) {
                    this.roomSessionData = response.data;
                    roomSessions = response.data;
                    console.log("success")
                    this.isOpenRoomStep('invoice')
                    this.printInvoiceData.service_total_value = response.data.total_service_value;
                    this.printInvoiceData.accessory_total_value = response.data.total_accessory_value;
                }
                else {
                    this.$notify({
                        title: `Not valid`,
                        text: response.message,
                        type: "warn"
                    });
                }
                let roomChargeTotal = 0;
                // roomSessions.forEach(roomSession => {
                if(this.selectedRoom.invoice.invoice_type == 'endless_time'){
                    roomChargeTotal = this.roomSessionData.total_session_price;
                }
                else{
                    // roomChargeTotal = roomSessions.total_session_price;
                    roomChargeTotal = 0
                }
                // roomChargeTotal += roomSession.price; // or roomSession.session_duration * roomSession.entity.price_per_hour;
                // });
                this.printInvoiceData.room = roomChargeTotal; // <== or that


                if (this.purchaseMenuList.length > 0) {
                    // this.printInvoiceData.food = this.purchaseMenuList[0].total
                    this.purchaseMenuList[0].order_items.forEach(element => {
                        this.orderList.push({
                            'menu_category_id': element.menu.menu_category_id,
                            'price': element.price,
                        })
                    });
                }
                if (this.selectedRoom.invoice.invoice_type == 'package') {
                    this.printInvoiceData.room = this.selectedRoom.invoice.total_session_price;
                    this.printInvoiceData.package_discount = this.selectedRoom.invoice.package.package_discount;
                    this.isPackage = true;
                    this.packagePrice = this.selectedRoom.invoice.paid_amount
                    // this.printInvoiceData.total = (this.printInvoiceData.room + this.printInvoiceData.food + this.printInvoiceData.service_total_value + this.printInvoiceData.accessory_total_value) - this.printInvoiceData.package_discount - this.foodDiscount;
                }
                else {
                    this.isPackage = false;
                    // this.printInvoiceData.total = (roomChargeTotal + this.printInvoiceData.food + this.printInvoiceData.service_total_value + this.printInvoiceData.accessory_total_value) - this.foodDiscount;
                }


                // room price = this.printInvoiceData.room
                if (this.service_charge = true) {
                    this.printInvoiceData.service_tax = this.printInvoiceData.total * 0.08
                }
                if (this.isTax = true) {
                    this.printInvoiceData.tax = this.printInvoiceData.food * (this.selectedTaxPercent * 0.01);
                }

                // this.printInvoiceData.total = this.printInvoiceData.room + this.printInvoiceData.food + this.printInvoiceData.tax +this.printInvoiceData.service_tax

                // this.selectedPaymentMethod = null
                this.change = null
                this.paid_amount = null
                this.printInvoiceData.discount = 0

            },

            btnClickedServiceCharge(){
                if (this.service_charge = true) {
                    this.printInvoiceData.service_tax = this.printInvoiceData.total * 0.08
                }
            },
            btnClickedTax(){
                if (this.isTax = true) {
                    // this.printInvoiceData.tax = (this.printInvoiceData.food - this.foodDiscount) * 0.05
                    let tax = this.selectedTaxPercent * 0.01
                    this.printInvoiceData.tax = (this.printInvoiceData.food - this.foodDiscount) * tax
                }
            },

            birthdayDiscountSelectChanged() {
                this.printInvoiceData.discount = this.birthday_discount.discount_value
                if (this.selectedRoom.invoice.invoice_type == 'package') {
                    this.printInvoiceData.room = (this.roomSessionData.total_session_price) - this.selectedRoom.invoice.package.package_discount;
                }
                else {
                    this.printInvoiceData.room = this.roomSessionData.total_session_price;
                }
                console.log(this.printInvoiceData.room,this.printInvoiceData.food,this.printInvoiceData.discount,this.foodDiscount);
                this.printInvoiceData.total = (this.printInvoiceData.room + this.printInvoiceData.food) - this.printInvoiceData.discount - this.foodDiscount
            },


            discountChanged() {
                // let roomTotalAmount = (this.roomSessionData.total_session_price + this.printInvoiceData.food) - this.printInvoiceData.package_discount - this.foodDiscount
                let roomTotalAmount = this.printInvoiceData.food - this.printInvoiceData.package_discount - this.foodDiscount
                console.log('room total = ' + this.printInvoiceData.room)
                if (this.discount_type == 'percentage') {
                    this.printInvoiceData.total = roomTotalAmount - (roomTotalAmount * (this.printInvoiceData.discount / 100));
                    this.printInvoiceData.percent_discount_amount = roomTotalAmount * (this.printInvoiceData.discount / 100);
                }
                else {
                    // this.printInvoiceData.total = roomTotalAmount - this.printInvoiceData.discount;
                    if(this.printInvoiceData.discount){
                        this.printInvoiceData.total = roomTotalAmount - this.printInvoiceData.discount;
                        console.log(this.printInvoiceData.discount)
                    }
                    else{
                        this.printInvoiceData.total = roomTotalAmount - this.printInvoiceData.discount;
                        console.log(this.printInvoiceData.discount)
                    }
                }
                console.log('room total amounttt = ' + roomTotalAmount);


            },

            btnClickedEndRoom() {
                this.EndRoom();
                // if(this.selectedPaymentMethod){
                //     this.EndRoom();
                // }
                // else{
                //     this.$notify({
                //         title: `Not valid`,
                //         text: 'Please Select Payment Method',
                //         type: "warn"
                //     });
                // }

            },
            async EndRoom() {
                let totalAmount = this.printInvoiceData.total;
                let allTotalDiscounts = 0;
                let formData = new FormData();
                formData.append('invoice_id', this.selectedRoom.invoice.id);
                // formData.append('payment_type', this.selectedPaymentMethod);
                formData.append('discount_type', this.discount_type);

                if (this.discount_type == 'fix_amount') {
                    formData.append('discount_value', this.printInvoiceData.discount);
                    // totalAmount = totalAmount - this.printInvoiceData.discount;
                }
                if (this.discount_type == 'percentage') {
                    formData.append('discount_value', this.printInvoiceData.percent_discount_amount);
                }
                if (this.discount_type == 'birthday_discount') {
                    formData.append('birthday_promotion_id', this.birthday_discount.id);
                    formData.append('birthday_discount', this.birthday_discount.discount_value);
                }
                else{
                    formData.append('birthday_discount', 0);
                }
                if(this.discount_type == 'customer_level'){
                    formData.append('customer_level_discount',this.roomSessionData.customer_level_discount_value);
                }
                else{
                    formData.append('customer_level_discount', 0);
                }
                formData.append('order_categories', JSON.stringify(this.orderList));
                if (this.printInvoiceData.service_charge) {
                    formData.append('service_charge', this.printInvoiceData.service_tax);
                    totalAmount = totalAmount + this.printInvoiceData.service_tax
                }
                else{
                    formData.append('service_charge', 0);
                }
                if (this.printInvoiceData.isTax) {
                    formData.append('tax', this.printInvoiceData.tax);
                    totalAmount = totalAmount + this.printInvoiceData.tax
                }
                else{
                    formData.append('tax', 0);
                }
                // formData.append('total', this.printInvoiceData.total);
                if (this.room_discount) {
                    formData.append('room_discount_amount', this.printInvoiceData.roomDiscountAmount);
                    formData.append('discount_session', this.printInvoiceData.discountSession);
                }
                if (this.selectedRoom.invoice.invoice_type == 'package') {
                    if(this.discount_type == 'percentage'){
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.package_discount + this.printInvoiceData.percent_discount_amount
                    }
                    else if(this.discount_type == 'customer_level'){
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.package_discount + this.roomSessionData.customer_level_discount_value
                    }
                    else if(this.discount_type == 'birthday_discount'){
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.package_discount + this.birthday_discount.discount_value
                    }
                    else{
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.discount + this.printInvoiceData.package_discount
                    }
                }
                else{
                    if(this.discount_type == 'percentage'){
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.percent_discount_amount
                    }
                    else if(this.discount_type == 'customer_level'){
                        allTotalDiscounts = this.foodDiscount + this.roomSessionData.customer_level_discount_value
                    }
                    else if(this.discount_type == 'birthday_discount'){
                        allTotalDiscounts = this.foodDiscount + this.birthday_discount.discount_value
                    }
                    else{
                        allTotalDiscounts = this.foodDiscount + this.printInvoiceData.discount
                    }
                }
                formData.append('total', totalAmount);
                formData.append('order_discount', this.foodDiscount);
                formData.append('discount_total', allTotalDiscounts);
                formData.append('end_date', this.serviceEndDate);
                formData.append('entity_type', this.entityType);
                formData.append('entity_id',this.selectedRoom.entity_id);
                formData.append("tax_percentage", this.selectedTaxPercent);


                let response = await postApiData({ url: '/api/entities/done', form_data: formData, token: this.getToken() });
                if (response.data) {
                    await this.getTableList();
                    this.isOpenRoom.step_1 = true;
                    this.isOpenRoom.step_2 = false;
                    this.isOpenRoom.step_detail = false;
                    this.isOpenRoom.step_invoice = false;

                    console.log("success")
                    console.log(response.data);
                    this.invoiceData = response.data;
                    this.isShowSidebar = false;

                    // window.location.reload()
                }
                else {
                    console.log('some errors occur');
                }
            },




            // async getSelectedRoom() {
            //     const response = await getApiData({ url: '/api/entities/' + this.selectedRoomId, token: this.getToken() });
            //     if (response.data) {
            //         this.selectedRoom = response.data;
            //     }
            // },


            // create customer
            async getGendersList() {
                const response = await getApiData({ url: '/api/genders', token: this.getToken() });
                if (response.data) {
                    this.genderList = response.data;
                }
            },

            async getDivisionList() {
                const response = await getApiData({ url: '/api/divisions', token: this.getToken() });
                if (response.data) {
                    this.divisionList = response.data;
                }
            },
            divisionSelectChanged() {
                this.getTownShipList();
            },
            async getTownShipList() {
                this.townshipList = this.divisionList.find(x => x.id === this.selectedDivision.id).townships;
            },

            createCustomerBtnClicked() {
                this.createCustomer();
            },
            async createCustomer() {
                console.log(this.email);
                // return 1;
                let formData = new FormData();
                formData.append('gender_id', this.selectedGender);
                formData.append('name', this.name);
                if (this.email != null) {
                    formData.append('email', this.email);
                }
                formData.append('phone_number', this.ph_number);
                formData.append('address_name', this.address_name);
                formData.append('address', this.address);
                formData.append('birthdate', this.date);
                formData.append('township_id', this.selectedTownship.id);
                let response = await postApiData({ url: '/api/customers', form_data: formData, token: this.getToken() });
                console.log(this.selectedGender + ',' + this.name + ',' + this.email + ',' + this.ph_number + ',' + this.address + ',' + this.date)
                if (response.success) {
                    this.customerList.push(response.data);
                    this.selectedCustomer = response.data;
                    console.log("success customer")
                    this.closeModal('closeCustomerModal');
                    this.clearCustomerForm();
                }
                else {
                    console.log('some errors occur');
                }
            },


            // add menu
            // async getMenuList() {
            //     const response = await getApiData({ url: '/api/menus?selling_area_id=' + this.area.id, token: this.getToken() });
            //     // const response = await getApiData({ url: '/api/menus', token: this.getToken() });
            //     if (response.data) {
            //         this.menuList = response.data;
            //     }
            // },
            async selectedMenuChange() {
            //     const response = await getApiData({ url: '/api/menus/' + this.selectedMenu.id + '/areas', token: this.getToken() });
            //     if (response.data) {
            //         this.menuAreaList = response.data.areas;
            //         this.menuQuantity = 1;
            //     }
                this.menuQuantity = 1;
            },
            btnClickAddMenu() {
                this.foodOrderPanelShown = true;
                this.invoiceId = this.selectedRoom.invoice.id;
                console.log('invoice id ' + this.invoiceId)
                this.menuQuantity = null;
                this.selectedMenu = null;
                this.remark = null;
                // this.getMenuList();
            },
            btnConfirmAddMenu() {
                this.addMenu();
            },
            async addMenu() {
                if(!this.selectedMenu){
                    this.showToastMessage('What menu do you want to order?');
                    return;
                }
                if(this.hasSellingExtras && this.selectedTableSellingExtras.length < 1){
                    this.showToastMessage('At least one extra must be selected');
                    return;
                }
                if(!this.menuQuantity){
                    this.showToastMessage('How much do you want to order?');
                    return;
                }
                let formData = new FormData();
                formData.append('invoice_id', this.invoiceId);
                formData.append('menu_id', this.selectedMenu.id);
                // formData.append('area_id', this.selectedMenuArea.id);
                formData.append('quantity', this.menuQuantity);
                formData.append('original_price', this.selectedMenu.prices[0].price);
                // formData.append('remark', this.remark);
                formData.append('selling_area_id', this.area.id);
                if(this.hasSellingExtras){
                    this.selectedTableSellingExtras.forEach(extra => {
                        formData.append('selling_extra_id[]', extra.id);
                    });
                }
                if(this.selectedTableRemark){
                    formData.append('remark_id',this.selectedTableRemark.id);
                }
                let response = await postApiData({ url: '/api/entities/orders', form_data: formData, token: this.getToken() });
                // console.log(this.invoiceId+','+this.selectedMenu.id + ','+ this.menuQuantity +','+this.selectedMenu.prices[0].price)
                if (response.success) {
                    this.hasSellingExtras = false;
                    this.selectedTableSellingExtras = [];
                    this.selectedTableRemark = null;
                    this.closeModal('closeAddMenuTableModal');
                    this.clearMenuForm();
                    // this.getPurchaseMenuList();
                    this.getSelectedRoom();
                    this.showToastMessage('New menu has been ordered, thank you!', 'success', 'Order Received');
                }
                else {
                    console.log('some errors occur');
                }
            },
            btnAddHour() {
                this.addHour();
            },
            async addHour() {
                let formData = new FormData();
                formData.append('invoice_id', this.selectedRoom.invoice.invoice_id);
                formData.append('session_duration', this.sessionDuration);
                let response = await postApiData({ url: '/api/entities/add_more_sessions', form_data: formData, token: this.getToken() });
                if (response.success) {
                    console.log("success")
                    await this.getTableList();
                    // this.selectedRoom = await this.roomList[this.selectedRoomIndex];
                    this.getSelectedRoom();
                    this.closeModal();
                    this.clearAddHourForm();
                }
                else {
                    this.$notify({
                        title: `Not valid`,
                        text: response.message,
                        type: "warn"
                    });
                }
            },
            btnClickedChangeRoom() {
                this.changeRoom();
            },
            async changeRoom() {
                let formData = new FormData();
                formData.append('invoice_id', this.selectedRoom.invoice.id);
                formData.append('entity_id', this.change_room.id);
                formData.append('entity_type', this.entityType);
                formData.append('previous_entity_id',this.selectedRoom.entity_id);
                let response = await postApiData({ url: '/api/entities/change', form_data: formData, token: this.getToken() });
                console.log('change room ' + this.selectedRoom.invoice.id + ',' + this.change_room.id)
                if (response.success) {
                    console.log("success");
                    await this.getTableList();
                    // this.selectedRoom = this.roomList.find(x => x.id === this.change_room.id);
                    this.selectedRoomId = this.change_room.id;
                    this.getSelectedRoom();
                    this.closeModal('change_table_modal');
                    this.clearChangeRoomForm();
                }
                else {
                    console.log('some errors occur');
                }
            },
            btnClickedGetChangeableRoomList() {
                this.getChangeableRoomList();
            },
            async getChangeableRoomList() {
                const response = await getApiData({ url: '/api/areas/' + this.tableAreaId + '/inactive_entities?type=table', token: this.getToken() });
                if (response.data) {
                    this.changeableRoomList = response.data;
                }
            },


            // add service
            // api/get_service?service_category_id=1&area_id=3 dj list
            btnClickAddService(){
                this.getServiceCategoryList();
            },
            async getServiceCategoryList() {
                const response = await getApiData({ url: '/api/service_categories', token: this.getToken() });
                if (response.data) {
                    this.serviceCategoryList = response.data;
                }
            },
            async getLadyList(){
                const response = await getApiData({ url: '/api/staff_by_department_slug/entertainment', token: this.getToken() });
                if (response.data) {
                    this.ladyList = response.data;
                }
            },
            async serviceCategoryChange(){
                const response = await getApiData({ url: '/api/get_service?service_category_id=' + this.selectedServiceCategory.id + '&area_id=' + this.tableAreaId, token: this.getToken() });
                if (response.data) {
                    if(this.selectedServiceCategory.name == 'DJ'){
                        this.djList = response.data;
                    }
                    else{
                        this.ladyList = response.data;
                    }

                }
            },
            btnConfirmAddService() {
                console.log('add services')
                this.addService();
            },
            async addService() {   // invoice pay yan
                let formData = new FormData();
                formData.append('invoice_id', this.selectedRoom.invoice.id);
                // formData.append('invoice_id', this.selectedServiceCategory);
                if(this.selectedServiceCategory.name == 'Lady'){
                    formData.append('service_id', this.selectedLady.id);
                }
                if(this.selectedServiceCategory.name == 'DJ'){
                    formData.append('service_id', this.selectedDj.id);
                }
                formData.append('start_date', this.selectedServiceStartTime);
                formData.append('remark', this.serviceRemark);
                let response = await postApiData({ url: '/api/entities/add_service', form_data: formData, token: this.getToken() });
                // console.log(this.invoiceId+','+this.selectedMenu.id + ','+ this.menuQuantity +','+this.selectedMenu.prices[0].price)
                if (response.success) {
                    this.closeModal('closeServiceModal');
                    this.clearServiceForm();
                    this.getSelectedRoom();
                }
                else {
                    this.$notify({
                        title: `Input validation`,
                        text: response.message,
                        type: "warn"
                    });
                }
            },
            btnClickedEndService(service){
                this.serviceEnd = service;
            },
            async btnConfirmEndService(){
                let formData = new FormData();
                formData.append('invoice_service_id', this.serviceEnd.id);
                formData.append('invoice_id', this.serviceEnd.invoice_id);
                formData.append('end_date', this.selectedServiceEndTime);
                let response = await postApiData({ url: '/api/entities/end_service', form_data: formData, token: this.getToken() });
                if (response.success) {
                    this.closeModal('closeEndServiceModal');
                    this.selectedServiceEndTime = null;
                    this.getSelectedRoom();
                }
                else {
                    this.$notify({
                        title: `Input validation`,
                        text: response.message,
                        type: "warn"
                    });
                }
            },


            // add accessory
            async getAccessoryCategoryList() {
                const response = await getApiData({ url: '/api/pos/get_accessory_category', token: this.getToken() });
                if (response.data) {
                    this.accessoryCategoryList = response.data;
                }
            },
            async accessoryCategoryChange(){ //get accessory list
                const response = await getApiData({ url: '/api/pos/accessory_by_category/'+ this.selectedAccessoryCategory.id, token: this.getToken() });
                if (response.data) {
                    this.accessoryList = response.data;
                }
            },
            btnConfirmAddAccessory() {
                this.addAccessory();
            },
            async addAccessory() {   // invoice pay yan
                let formData = new FormData();
                formData.append('invoice_id', this.selectedRoom.invoice.id);
                formData.append('accessory_id', this.selectedAccessory.id);
                formData.append('quantity', this.selectedAccessoryQuantity);
                formData.append('accessory_price', this.selectedAccessory.accessory_price.price);
                let response = await postApiData({ url: '/api/pos/add_accessory', form_data: formData, token: this.getToken() });
                // console.log(this.invoiceId+','+this.selectedMenu.id + ','+ this.menuQuantity +','+this.selectedMenu.prices[0].price)
                if (response.success) {
                    this.getSelectedRoom();
                    this.closeModal('closeAccessoryModal');
                    this.clearAccessoryForm();
                }
                else {
                    this.$notify({
                        title: `Input validation`,
                        text: response.message,
                        type: "warn"
                    });
                }
            },


            closeModal(modalId) {
                document.getElementById(modalId).click();
            },
            clearCustomerForm() {
                this.name = null
                this.ph_number = null
                this.email = null
                this.selectedGender = null
                this.date = null
                this.selectedDivision = null
                this.selectedTownship = null
                this.address_name = null
                this.address = null
            },
            clearMenuForm() {
                this.invoiceId = null
                this.menuQuantity = null
                this.selectedMenu = null
                this.remark = null
            },
            clearAddHourForm() {
                this.sessionDuration = null
            },
            clearChangeRoomForm() {
                this.change_room = null
            },
            clearServiceForm() {
                this.selectedServiceCategory = null
                this.selectedLady = null
                this.selectedDj = null
                this.selectedServiceQuantity = null
            },
            clearAccessoryForm() {
                this.selectedAccessoryCategory = null
                this.selectedAccessory = null
                this.selectedAccessoryQuantity = null
            },
            clearOpenRoomForm() {
                this.selectedCustomer = null
                this.type = null;
                this.selectedPackage = null
                this.deposit = null
                this.invoice_date = null
                this.duration = null
                this.male = null
                this.female = null
                this.child = null
            },
            showSidebar(){
                if(this.isShowSidebar){

                    this.isOpenRoom.open_1 = false;
                    this.isOpenRoom.open_2 = false;
                    this.isOpenRoom.detail = true;
                    this.isOpenRoom.invoice = false;
                    this.isShowSidebar = false;

                }
                else{
                    this.isShowSidebar = true
                }
            },
            isOpenRoomStep(selectedKey) {
                for (let key in this.isOpenRoom) {
                    if (key === selectedKey) {
                        this.isOpenRoom[key] = true;
                    }
                    else {
                        this.isOpenRoom[key] = false;
                    }
                }
            },
            async getCashAccounts(){
                let response = await getApiData({url: `/api/get_cash_account`, token: this.getToken()});
                if(response.success){
                    let posCashAccount = response.data.find(account => account.account_code === '2-1011');
                    if (posCashAccount) {
                        this.cashAccounts.push(posCashAccount);
                    }
                    let posBankAccount = response.data.find(account => account.account_code === '2-1012');
                    if (posBankAccount) {
                        this.cashAccounts.push(posBankAccount);
                    }
                    // this.cashAccounts = response.data;
                }
            },

            nameWithPrice ({name, prices}) {
                return `${name} (${prices[0].price}Ks)`
            },

            sellingExtraName(sellingExtra){
                return `${sellingExtra.item.name}`;
            },

            getMenuCategoryList() {
                getApiData({ url: '/api/menu_categories', token: this.getToken() })
                .then((response)=>{
                    if(response.success){
                        this.menuCategoryList = response.data;
                        this.selectedMenuCategory = this.menuCategoryList[0];
                        if(this.entityDetails){
                            this.getMenuList(this.entityDetails.area_id);
                        }
                    }
                })
            },

            getMenuList(sellingAreaId){
                const url = `/api/menu_categories/${this.selectedMenuCategory.id}/menus?selling_area_id=${sellingAreaId}`;
                getApiData({url: url, token: this.getToken()})
                .then((response)=>{
                    this.menuLoading = false;
                    if(response.success){
                        this.menuList = response.data;
                    }
                });
            },

            menuCategorySelectChanged(category){
                this.menuSearchQuery = '';
                this.menuList = [];
                this.selectedMenuCategory = category;
                this.menuLoading = true;
                if(this.entityDetails){
                    this.getMenuList(this.entityDetails.area_id);
                }
            },

            addToOrderBtnClicked(menu){
                this.getPurchaseMenuList();
                let existingMenu = this.cartMenus.find((eachMenu)=>eachMenu.menu_id === menu.id);
                if(existingMenu){
                    const index = this.cartMenus.findIndex(menu => menu.menu_id === existingMenu.menu_id);
                    this.cartMenus[index].quantity += 1;
                    this.cartMenus[index].price = this.cartMenus[index].quantity * this.cartMenus[index].unit_price;
                }else{
                    this.cartMenus.push({
                        menu_id: menu.id,
                        name: menu.name,
                        code: menu.code,
                        quantity: 1,
                        price: menu.prices[0].price,
                        unit_price: menu.prices[0].price,
                        original_price: menu.prices[0].price,
                        menu_category_id: this.selectedMenuCategory,
                        cooking_area_id: menu.cooking_area_id,
                        is_package: 0,
                        is_foc: 0,
                        foc_applied: false,
                    });
                }

                this.updateCartMenusPriceTotal();
            },

            removeMenuFromCart(menu, index){
                this.cartMenus.splice(index, 1);
                this.updateCartMenusPriceTotal();
            },

            updateCartMenusPriceTotal(){
                this.cartMenusPriceTotal = this.cartMenus.reduce((total, menu) => {
                    // If foc_applied is true, amount is 0; otherwise, use the parsed price
                    const amount = menu.foc_applied ? 0 : (Number(menu.price) || 0);
                    menu.is_foc = (menu.foc_applied)? 1:0;
                    return total + amount;
                }, 0);
                this.cartMenusFocTotal = this.cartMenus.reduce((total, menu) => {
                    // If foc_applied is false, amount is 0; otherwise, use the parsed price
                    const amount = (!menu.foc_applied) ? 0 : (Number(menu.price) || 0);
                    return total + amount;
                }, 0);
            },

            confirmMenuOrder(){
                this.menuOrderBtnLoading = true;
                let formData = new FormData();
                formData.append('menuArray', JSON.stringify(this.cartMenus))
                formData.append('invoice_id', this.entityDetails.invoice.id);
                formData.append('selling_area_id', this.entityDetails.area_id);
                postApiData({ url: '/api/entities/orders', form_data: formData, token: this.getToken() })
                .then((response)=>{
                    this.menuOrderBtnLoading = false;
                    if(response.success){
                        this.getPurchaseMenuList();
                        this.cartMenus = [];
                        this.cartMenusPriceTotal = 0;
                        this.menuSearchQuery = '';
                        this.foodOrderPanelShown = false;
                    }else{
                        this.$notify({
                            text: response.message,
                            type: "error"
                        });
                    }
                })
            },

            cancelMenuOrder(){
                this.cartMenus = [];
                this.cartMenusPriceTotal = 0;
                this.menuSearchQuery = '';
                this.foodOrderPanelShown = false;
            },
        },

        watch: {
            invoiceData(newData) {
            if (newData !== null) {
                this.$nextTick(() => {
                    this.handlePrint();
                });
            }
        },
            hasSellingExtras(){
                if(!this.hasSellingExtras){
                    this.selectedTableSellingExtras = [];
                }
            },
            selectedRoom(val, oldVal) {
                console.log(`new: ${val}, old: ${oldVal}`)
            },

            // tableAreaId(newId) {
            //     this.getTableList(newId);
            // },
            area(area){
                this.getTableList(area);
            },
            isPreDeposit(){
                if(!this.isPreDeposit){
                    this.deposit = null;
                    this.selectedCashAccount = null;
                }
            },
        },
        computed: {
            mappedItems() {
            if (!this.invoiceData) return [];
            return this.invoiceData.orders.map(order => ({
                category: order.name,
                list: order.items.map(item => ({
                    name: item.name,
                    qty: item.total_quantity,
                    price: item.total_amount
                }))
            }));
        },
        totalQuantity() {
            if (!this.invoiceData) return 0;
            return this.mappedItems.reduce((acc, group) =>
                acc + group.list.reduce((sum, item) => sum + Number(item.qty), 0), 0
            );
        },
        summaryRows() {
            if (!this.invoiceData) return [];
            const d = this.invoiceData;
            
            return [
                { label: 'Subtotal', value: d.total.toLocaleString() },
                ...d.tax ? [{ label: `Tax (${this.selectedTaxPercent})`, value: d.tax.toLocaleString() }] : [],
                ...d.service_charge ? [{ label: 'Service Charge (8%)', value: d.service_charge.toLocaleString() }] : [],
                ...d.discount ? [{ label: 'Discount', value: `-${Number(d.discount).toLocaleString()}` }] : [],
                { label: 'Total', value: d.sub_total.toLocaleString(), isBold: true }
            ];
        },
        formattedDate() {
            return this.invoiceData?.invoice_date.split(' ')[0] || '';
        },
        formattedTime() {
            return this.invoiceData?.invoice_date.split(' ')[1] || '';
        },
            filteredMenuList() {
                const query = this.menuSearchQuery.trim().toLowerCase();
                if (!query) {
                    return this.menuList;
                }
                const q = query.toLowerCase().trim();

                return this.menuList.filter(menu =>
                    (menu.name || "").toLowerCase().includes(q) ||
                    (menu.description || "").toLowerCase().includes(q)
                );
            },
            combinedMenuList() {
                const map = {};
                this.purchaseMenuList[0].order_items.forEach(item => {
                    const key = item.menu_id + '-' + item.status;
                    if (!map[key]) {
                        map[key] = { ...item };
                    }
                    else {
                        map[key].quantity += item.quantity;
                        map[key].price += item.price;
                    }
                });
                return Object.values(map);
            },
        },
        created(){
            // this.getCustomerList();
            // this.getGendersList();
            // this.getMenuList();
            // this.getDivisionList();
            this.getPackageList(this.currentTime);
            this.getCashAccounts();
            // this.getServiceCategoryList();
            // this.getLadyList();

            // this.getAccessoryCategoryList();
        },
        mounted()
        {
            // if (this.tableAreaId) {
            //     this.getTableList(this.tableAreaId);
            // }
            initTE({ Modal, Select, Ripple, Datepicker });
        }
    }
</script>
<style src="node_modules/vue-multiselect/dist/vue-multiselect.css">
</style>
<style scoped>
/* 1. Register the local TTF font file */
@font-face {
  font-family: 'MyLocalTimes';
  src: url('/fonts/times.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.receipt-container {
    font-family: 'MyLocalTimes', 'Times New Roman', Times, serif;
    width: 80mm;
    padding: 8mm 5mm;
    font-size: 13px;
    line-height: 1.2;
    color: #333;
}
.header-top {
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: 10px;
}
.brand-name {
    font-size: 22px;
    margin: 0;
    font-weight: bold;
}
.meta-grid {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 12px;
}
.meta-right {
    text-align: right;
}
.italic {
    font-style: italic;
    font-weight: bold;
}
.category {
    font-weight: bold;
    margin: 8px 0 2px 0;
}
.item-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    text-align: right;
    margin-bottom: 5px;
}
.item-row span:first-child {
    text-align: left;
}
.total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
}
.align-right {
    justify-content: flex-end;
    gap: 40px;
}
.align-right span:first-child {
    width: 120px;
    text-align: right;
}
.bold {
    font-weight: bold;
}
hr.solid-thick {
    border: none;
    border-top: 2px solid #000;
    margin: 10px 0;
}
.footer-info {
    margin-top: 20px;
    font-size: 11px;
}
.center {
    text-align: center;
}
@media print {
    @page {
        margin: 0;
    }
    .receipt-container {
        width: 100%;
    }
}
</style>
